function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgJavascript = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26pt",
  height: "26pt",
  viewBox: "0 0 26 26",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 26,
  height: 26,
  style: {
    fill: "rgb(96.862745%,87.45098%,11.764706%)",
    fillOpacity: 1,
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "rgb(0%,0%,0%)",
    fillOpacity: 1
  },
  d: "M 17.464844 20.3125 C 17.988281 21.167969 18.671875 21.796875 19.875 21.796875 C 20.886719 21.796875 21.535156 21.289062 21.535156 20.589844 C 21.535156 19.753906 20.871094 19.457031 19.757812 18.96875 L 19.144531 18.707031 C 17.382812 17.957031 16.210938 17.015625 16.210938 15.027344 C 16.210938 13.195312 17.605469 11.796875 19.789062 11.796875 C 21.34375 11.796875 22.460938 12.339844 23.265625 13.753906 L 21.359375 14.976562 C 20.941406 14.226562 20.492188 13.929688 19.789062 13.929688 C 19.074219 13.929688 18.621094 14.382812 18.621094 14.976562 C 18.621094 15.710938 19.074219 16.007812 20.121094 16.460938 L 20.734375 16.722656 C 22.808594 17.613281 23.980469 18.519531 23.980469 20.558594 C 23.980469 22.757812 22.253906 23.964844 19.933594 23.964844 C 17.664062 23.964844 16.195312 22.882812 15.480469 21.464844 Z M 8.835938 20.523438 C 9.21875 21.207031 9.566406 21.78125 10.40625 21.78125 C 11.210938 21.78125 11.714844 21.46875 11.714844 20.246094 L 11.714844 11.9375 L 14.160156 11.9375 L 14.160156 20.277344 C 14.160156 22.808594 12.675781 23.960938 10.511719 23.960938 C 8.554688 23.960938 7.421875 22.949219 6.847656 21.726562 Z M 8.835938 20.523438 "
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJavascript, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/javascript.864fa02b.svg";
export { ForwardRef as ReactComponent };